import { getSubPage } from "../../api/formatters/dashboard";
import { AnalyticsSubMenu, WidgetsSubMenu } from "../../types/navigation";

export const subMenuObject = (menu: "analytics" | "widget") => {
  switch (menu) {
    case "analytics":
      return AnalyticsSubMenu;
    case "widget":
      return WidgetsSubMenu;
    default:
      return AnalyticsSubMenu;
  }
};
export const shouldSubMenuBeOpen = (
  menu: "analytics" | "widget",
  pathName?: string
) => {
  if (pathName) {
    if (getSubPage(location.pathname, subMenuObject(menu))) {
      return true;
    }
  }

  return false;
};
